import { apiGet, apiPostPut, apiDeleteWithBody } from "./api_methods";
import {
  RECRUITER_USERS_BASE,
  AUTH_CHANGE_PASSWORD,
  AUTH_DELETE_USER,
} from "./endpoints";

/**
 * Get all team members for the recruited user.
 * @returns {Promise<{ body, status }>}
 */
export async function getAllTeamMembers(params = {}) {
  const query = new URLSearchParams(params).toString();
  const queryString = query ? `?${query}` : "";
  return apiGet(`${RECRUITER_USERS_BASE}/all-members${queryString}`);
}

/**
 * Get recruiter profile details.
 * POST /api/v1/recruiter/users/details
 * @param {object} payload - Optional { id: "..." }, defaults to authenticated user.
 * @returns {Promise<{ body, status }>}
 */
export async function getRecruiterProfile(payload = {}) {
  return apiPostPut(payload, `${RECRUITER_USERS_BASE}/details`, "POST");
}

/**
 * Update recruiter profile details.
 * PUT /api/v1/recruiter/users/:id
 * @param {string} id - Recruiter profile _id.
 * @param {object} updateBody - Fields to update.
 * @returns {Promise<{ body, status }>}
 */
export async function updateRecruiterProfile(id, updateBody) {
  return apiPostPut(updateBody, `${RECRUITER_USERS_BASE}/${id}`, "PUT");
}

/**
 * Change password for the authenticated recruiter.
 * PUT /api/v1/auth/change-password
 * @param {object} payload - { mail, oldPassword, newPassword }
 * @returns {Promise<{ body, status }>}
 */
export async function changePassword(payload) {
  return apiPostPut(payload, AUTH_CHANGE_PASSWORD, "PUT");
}

/**
 * Delete (soft-delete) the authenticated recruiter account.
 * DELETE /api/v1/auth/delete-user
 * @param {object} payload - Optional { reason: "..." }
 * @returns {Promise<{ body, status }>}
 */
export async function deleteRecruiterAccount(payload = {}) {
  return apiDeleteWithBody(payload, AUTH_DELETE_USER);
}
